/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Order_Summary_SubtotalInputs */

const en_admin_external_booking_edit_order_summary_subtotal = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotal`)
};

const de_admin_external_booking_edit_order_summary_subtotal = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischensumme`)
};

const es_admin_external_booking_edit_order_summary_subtotal = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotal`)
};

const fr_admin_external_booking_edit_order_summary_subtotal = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-total`)
};

const nl_admin_external_booking_edit_order_summary_subtotal = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtotaal`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_subtotal = en_admin_external_booking_edit_order_summary_subtotal;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_subtotal = en_admin_external_booking_edit_order_summary_subtotal;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_subtotal = en_admin_external_booking_edit_order_summary_subtotal;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_subtotal = en_admin_external_booking_edit_order_summary_subtotal;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_subtotal = en_admin_external_booking_edit_order_summary_subtotal;

/**
* | output |
* | --- |
* | "Subtotal" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_SubtotalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_subtotal = /** @type {((inputs?: Admin_External_Booking_Edit_Order_Summary_SubtotalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_SubtotalInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_subtotal(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_subtotal(inputs)
	return ro_admin_external_booking_edit_order_summary_subtotal(inputs)
});
export { admin_external_booking_edit_order_summary_subtotal as "admin.external_booking_edit.order_summary.subtotal" }